import { ArrowDown2, ArrowRight2 } from "iconsax-react";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { FaAngleRight } from "react-icons/fa6";
import { Link, useLocation } from "react-router-dom";

const MegaMenu = ({ data }) => {
  const location = useLocation();
  const [show, setShow] = useState();
  const [t, i18n] = useTranslation("global");

  return (
    <>
      <span
        onMouseEnter={() => setShow(true)}
        onMouseLeave={() => setShow(false)}
        className="lg:flex gap-1 items-center nav-item nav-link relative hidden "
      >
        {" "}
        {t("other-category")}
        <ArrowDown2
          className={`${show ? "rotate-180" : "rotate-0"} duration-200 mb-1`}
          color="#fff"
          size={18}
        />
        <div
          className={`${
            show ? "opacity-100 max-h-96 z-50" : " opacity-0 max-h-0 -z-10"
          } duration-200 absolute left-1/2 top-full bg-[#ffff] shadow text-[#000] text-[16px] text-center font-bold w-[260px] -translate-x-1/2 overflow-hidden`}
        >
          <div className="flex flex-col gap-3 p-3">
            {data?.slice(5, 20)?.map((cat) => (
              <Link
                to={`/category/${cat?.url}`}
                class={`flex gap-1 items-center justify-between ${
                  location.pathname === `/category/${cat?.url}` ? "active" : ""
                }`}
              >
                {cat?.[`name_${i18n.language}`] || cat?.name} <FaAngleRight />
              </Link>
            ))}
          </div>
        </div>
      </span>
    </>
  );
};

export default MegaMenu;
